<template>
  <div class="detail">
  	<div class="container">
  		<div class="title">
  			{{data.categoryName}}
  		</div>
  		<div class="line">

  		</div>
  		<div class="des">
  			{{data.description}}
  		</div>
  	</div>
  </div>
</template>

<script>
  export default {
    name: 'Footer',
    components:{

    },
    data () {
      return {
        id:this.$route.query.id,
        data:{}
      }
    },
    methods:{
      getData(){
        this.$axios.get(this.$common.categorys_description+'?classifyId='+this.$route.query.id).then((res)=>{
              if(res.data.code==1){

                    this.data=res.data.data;

              }
              else {
                alert(res.data.msg)
              }
        })
      }
    },
    created() {
      this.getData();
    },
    watch:{
       '$route' (to, from) {
          // data数据操作
          this.getData();
        }
    }
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/detail.vue